import React from 'react';
import { User, GraduationCap, Target, MessageCircle, BarChart3, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSiteContent } from '../../context/SiteContentContext';

const iconMap = [User, GraduationCap, Target, MessageCircle, BarChart3, Calendar];
const colorMap = [
  'bg-blue-50 text-blue-600',
  'bg-emerald-50 text-emerald-600',
  'bg-violet-50 text-violet-600',
  'bg-amber-50 text-amber-600',
  'bg-rose-50 text-rose-600',
  'bg-cyan-50 text-cyan-600'
];

const WhatWeOffer = () => {
  const { siteContent } = useSiteContent();
  const whatWeOffer = siteContent?.whatWeOffer || {};

  if (whatWeOffer.visible === false) return null;

  const items = whatWeOffer.items || [];

  return (
    <section className="py-14 sm:py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-10 sm:mb-14"
        >
          <span className="text-xs sm:text-sm font-medium text-slate-400 uppercase tracking-wider mb-3 sm:mb-4 block">
            {whatWeOffer.label || 'Services'}
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            {whatWeOffer.title || 'What We Offer'}
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
          {items.map((item, index) => {
            const Icon = iconMap[index % 6];
            const color = colorMap[index % 6];
            const itemKey = item.title?.en || item.title || `offer-${index}`;
            return (
              <motion.div
                key={itemKey}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ duration: 0.5, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="bg-slate-50 hover:bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 border border-slate-100 hover:border-slate-200 hover:shadow-lg transition-all duration-300"
              >
                <div className={`w-10 h-10 sm:w-12 sm:h-12 ${color} rounded-lg sm:rounded-xl flex items-center justify-center mb-3 sm:mb-4`}>
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.75} />
                </div>
                <h3 className="text-sm sm:text-base md:text-lg font-semibold text-slate-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs sm:text-sm text-slate-500">
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
